import React, { useState } from "react";
import "../InputStyles.css";
import { Eye, EyeOff } from "lucide-react";

const InputField = ({
    label,
    type = "text",
    value,
    name,
    onInput,
    onChange,
    placeholder,
    style,
    disabled = false,
    readonly,
    error,
    suffix,
    tooltip,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const isPassword = type === "password";
    const inputType = isPassword ? (showPassword ? "text" : "password") : type;
    const inputId = name || "input_" + Math.random().toString(36).substr(2, 9);

    return (
        <div className="input_group" style={{ position: "relative" }}>
            <input
                id={inputId}
                type={inputType}
                value={value}
                onInput={onInput}
                onChange={onChange}
                name={name}
                placeholder={placeholder}
                className="input_field"
                style={{ ...style, paddingRight: suffix ? "2.2em" : undefined }}
                disabled={disabled}
                readOnly={readonly}
            />

            {label && <label className="input_label" htmlFor={inputId}>{label}</label>}

            {isPassword && (
                <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="toggle-password"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
            )}

            {suffix && (
                <span
                    className="input_suffix"
                    style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "whitesmoke",
                        pointerEvents: "none",
                        fontSize: "1.3em",
                    }}
                >
                    {suffix}
                </span>
            )}
        </div>
    );
};

export default InputField;
